export enum TypeButtonAppEnum {
  redirect = 1,
  sideBar = 2,
}

export enum TAppSideBar {
  voxuy = 1,
  gtm = 2,
}

export type TApp = {
  name: string
  to: string
  image: string
  typeButton: TypeButtonAppEnum
  sideBar?: TAppSideBar | undefined
}

export const apps: TApp[] = [
  {
    name: 'Voxuy',
    to: '',
    image: '/assets/apps/voxuy.svg',
    typeButton: TypeButtonAppEnum.sideBar,
    sideBar: TAppSideBar.voxuy,
  },
  {
    name: 'Astron Members',
    to: '/apps/astronmembers',
    image: '/assets/apps/astronMembers.svg',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'Notazz',
    to: '/apps/notazz',
    image: '/assets/apps/notazzIcon.png',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'Active Campaign',
    to: '/apps/activecampaign',
    image: '/assets/apps/activeCampaing.svg',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'Webhooks',
    to: '/apps/webhooks',
    image: '/assets/apps/webhooks.svg',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'Google Tag Manager',
    to: '',
    image: '/assets/apps/gtm.png',
    typeButton: TypeButtonAppEnum.sideBar,
    sideBar: TAppSideBar.gtm,
  },
  {
    name: 'The Members',
    to: '/apps/themembers',
    image: '/assets/apps/theMembers.svg',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'Cademí',
    to: '/apps/cademi',
    image: '/assets/apps/cademi.svg',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'UTMIfy',
    to: '/apps/utmfy',
    image: '/assets/apps/utmfy.png',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'MemberKit',
    to: '/apps/memberkit',
    image: '/assets/apps/memberkit.png',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
  {
    name: 'SellFlux',
    to: '/apps/sellflux',
    image: '/assets/apps/sellflux.webp',
    typeButton: TypeButtonAppEnum.redirect,
    sideBar: undefined,
  },
]
